<template>
  <div>
    <div ref="fadeWhenModelOpen">
      <div style="height:50px;    display: inline-flex;width: 100%;" class="comm-settings-top-nav">
          <div class="search-bar-comm-style col-md-6" style="display:inline-flex">
              <!-- <input
                  type="text"
                  class="rounded text-light search-bar"
                  placeholder="Search screen"
                  autocomplete="off" v-model="searchFilters.name" @input="getWebHookData(false)"/> -->
          </div>
          <div class="primary-btn-style justify-content-end d-inline-flex col-md-6" style="padding:11px;">
               <button class="learn-about-text-styles" @click="openLearnAboutPanel()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lightbulb-fill" viewBox="0 0 16 16">
                  <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/>
                  </svg>{{$t('Learn about Web hook')}}
                </button> 
              <!-- <button class="btn btn-outline-danger mt-2 mr-2" style="border: 1px solid #831515;"  v-on:click="deleteWebHookNth()">Delete</button> -->
              <!-- <button class="btn btn-outline-secondary m-2" style="border: 1px solid #585858;"  v-on:click="editWebHook('add-webhook')">Edit</button> -->
              <button class="btn btn-outline-primary m-2" v-on:click="changeToSelectedwebhookComponent('add-webhook')">{{$t('Add')}}</button>
          </div>
      </div>
      <div class="p-4 height-set-for-component">
        <table class="table-with-border table-scroll small-first-col" style="background: transparent">
          <thead style="color: #eee">
            <tr>
              <th class="text-left" style="width:40%">{{$t('Name')}}</th>
              <th style="text-align:center;width:14%"> {{$t('DateCreated')}}</th>
              <th style="text-align:center;width:8%">{{$t('Workflow')}}</th>
              <th style="text-align:center;width:30%">{{$t('Triggers')}}</th>
              <th style="text-align:center;width:8%">{{$t('Status')}}</th>
            </tr>
          </thead>
          <tbody class="body-half-screen">
            <tr v-for="item in webHooksList" :key="item._id" @click="selectRow(item), changeToSelectedwebhookComponent('add-webhook', item)" :class="{activeclass: activeRow == item._id}" :id="item._id" class="comm-user-row show-delete-icon">
              <td style="word-break:break-all;width:40%">{{item.hookscript_name }}</td>
              <td style="text-align:center;width:14%">
                <span v-if="Object.keys(item).includes('created_datetime') && item.created_datetime != null && item.created_datetime.length > 0" :title="getDateAndTimeInConfiguredFormat(item.created_datetime)">{{getDateAndTimeInConfiguredFormat(item.created_datetime, true)}}</span>
                <span v-else> - </span>
              </td>
              <td v-if="item.isWorkflowTask == true"  :class="{ activestatus: item.isWorkflowTask === true }" style="text-transform: capitalize;text-align:center;width:8%;text-align:center">
                {{$t('Enabled')}}
              </td>
              <td v-else style="text-align:center;color:#9e9999">
                {{$t('Disabled')}}
              </td>
              <td sty v-if="item.trigger_id_list.length>0" style="text-align:center;width:30%">
                <span>{{getTriggerName(item.trigger_id_list[0])}}</span> <span v-show="item.trigger_id_list.length>1" style="color:#898888"> +{{item.trigger_id_list.length - 1}}</span>
              </td>
              <td v-else style="text-align:center;width:30%"> - </td>
              <td style="text-align:center">
                <span v-if="item.enable == true" :class="{ activestatus: item.enable === true }" style="color: #cb0707; text-transform: capitalize;text-align:center;width:8%;text-align:center">
                  {{$t('Active')}} 
                </span>
                <span v-else style="text-transform: capitalize;text-align:center;width:8%;text-align:center;color:#cb0707">
                  {{$t('Disabled')}} 
                </span>
                 <svg @click.stop.prevent="deleteWebHookNth(item)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash parent-row-delete" viewBox="0 0 16 16" style="margin-inline-start:10px;">
                    <title>{{$t('Delete')}}</title>
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                    <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                </svg>
                <svg  @click.stop.prevent="editWebHook('add-webhook', item)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil parent-row-edit" viewBox="0 0 16 16" style="margin-inline-start:10px;">
                  <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                </svg>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <component :is="selectedComponenet" @close="closeLearnAboutPanel"></component>
    <div>
      <pagination
          v-model="page"
          :records="totalWebHooks"
          :per-page="perPage"
          @paginate="paginate"
          :options="options"
          style="margin-top:10px"
      />
    </div>
  </div>
</template>


<script>
import { mapActions, mapMutations } from "vuex";
import Utils from "../../components.utils.js"
// import Multiselect from 'vue-multiselect';
import LearnAbout from "./LearnAboutWebhook.vue"
import Pagination from "vue-pagination-2";
import {NotifierConstants} from "../../components.constants.js";

 
export default {
  name:'MultiSelect',
  props:['triggersList'],
  data(){
    return {
      activeIndex: null,
      page: 1,
      totalPages: -1,
      totalWebHooks: -1,
      perPage: -1,
      options:{chunk:5},
      webHooksList: [],
      selectedRowDetails:{},
      activeRow:null,
      selectedComponenet:null,
      searchFilters:{
        type:'all'
      }
     
    };
  },
  components:{
    pagination: Pagination,
    // "Multiselect":Multiselect,
    "learn-about":LearnAbout
  },
  methods: {

    openLearnAboutPanel(){
      this.selectedComponenet = 'learn-about';
      this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
      this.$refs.fadeWhenModelOpen.style.pointerEvents = "none";
    },
    closeLearnAboutPanel(){
      this.selectedComponenet = null;
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
      this.$refs.fadeWhenModelOpen.style.pointerEvents = "auto";
    },

    formatDateAndTime(date){
      return Utils.getDateAndTimeFormat(date);
    },
      
    changeToSelectedwebhookComponent(compName, webHookInfo={}){
      this.$emit("changeToSelectedwebhookComponent", compName, webHookInfo)
    },

    editWebHook(comp, selectedItem){
      if(selectedItem._id != undefined){
        this.changeToSelectedwebhookComponent(comp,selectedItem)
      }else{
        alert("Select Web hook to edit");
        return false;
      }
    },

    getTriggerenaabledIcon(triggerEnabled){
      if(triggerEnabled == true){
        return '<svg data-v-f65a9d9c="" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#57af57" viewBox="0 0 16 16" class="bi bi-check-circle-fill"><path data-v-f65a9d9c="" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path></svg>';
      }else{
        return "Disabled";
      }
    },

    selectRow(key){
      this.selectedRowDetails = key;
      this.activeRow = key._id;
    },

    getTriggerName(triggerId){
      let triggerObjIdx = this.triggersList.findIndex((Obj)=>Obj._id == triggerId);
      if(triggerObjIdx && triggerObjIdx>=0){
        return this.triggersList[triggerObjIdx].name;
      }
      return "";
    },

    deleteWebHookNth(selectedItem){
      if(selectedItem != undefined){
        this.deleteWebHook(selectedItem.hookscript_name, selectedItem._id)
      }else{
        alert("Select web hook to delete");
        return false;
      }
    },
    deleteWebHook(webHookName, webHookId) {
      let payload = {};
      payload["webHookId"] = webHookId;
      if (confirm(`Are You sure you want to delete the selected Web hook : "${webHookName}" ?`)) {
        this.deleteExistingWebHook(payload).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)){
            if(data.message) this.$toast.success(data.message);
          } else{
            if(data.message) this.$toast.error(data.message);
          }
        });
        // this.updateBinsList()
      }
    },
    // addBinToList(bin_info){
    //   let bin_exists = this.binsList.filter((bin)=>bin.bin_id==bin_info.bin_id)
    //   if (bin_exists.length ==0){
    //     this.binsList.push(bin_info)
    //   }else{
    //     Object.assign(bin_exists[0], bin_info)
    //   }
    // },


    getWebHookData(isPageClick = false){
      let payload = {};
      let paramsInfo = {};
       if(isPageClick){
          paramsInfo['page'] = this.page;
        }

      if(typeof(this.searchFilters.name) != 'undefined' &&
      this.searchFilters.name.trim().length > 0){
        paramsInfo.name = this.searchFilters.name
      }

      if(typeof(paramsInfo) != 'undefined'){
        payload.params = paramsInfo
      }

        
      this.getWebHookScriptFromServer(payload).then((data) =>{
        this.webHooksList = data.hook_scripts;
        this.totalPages = data["page_count"];
          this.totalWebHooks = data["total_hook_scripts"];
          this.perPage = data["hook_scripts_per_page"];
      });  
    },

    paginate(page){
        // this.currentPage = page;
            this.page = page;
            this.totalPages= -1;
            this.totalWebHooks= -1;
            this.perPage= -1;
            this.getWebHookData(true);
    },
   
      handleWebHookWorkspaceNotification(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
          let messageInfo = notification.message;
          if (notification.message_type == NotifierConstants.webHookCreateNotification){
                this.webHooksList.unshift(messageInfo);
          }else if (notification.message_type == NotifierConstants.webHookUpdateNotification){
               let updatedWebHookObj = this.webHooksList.filter((webHookObj)=>webHookObj._id == messageInfo.hookscript_id);
               if (updatedWebHookObj.length !=0){
                    updatedWebHookObj = updatedWebHookObj[0];
                    if(Object.keys(messageInfo).includes("hookscript_name")){
                        this.$set(updatedWebHookObj, "hookscript_name", messageInfo.hookscript_name)
                    }

                    if(Object.keys(messageInfo).includes("created_datetime")){
                        this.$set(updatedWebHookObj, "created_datetime", messageInfo.created_datetime)
                    }

                    if(Object.keys(messageInfo).includes("enable")){
                        this.$set(updatedWebHookObj, "enable", messageInfo.enable)
                    }

                    if(Object.keys(messageInfo).includes("isWorkflowTask")){
                        this.$set(updatedWebHookObj, "isWorkflowTask", messageInfo.isWorkflowTask)
                    }

                    if(Object.keys(messageInfo).includes("trigger_id_list")){
                        this.$set(updatedWebHookObj, "trigger_id_list", messageInfo.trigger_id_list)
                    }
                }            
          }else if (notification.message_type == NotifierConstants.webHookDeleteNotification){
              this.webHooksList = this.webHooksList.filter((webHookObj)=>webHookObj._id != messageInfo._id);
          }
      },

      registerforWebsocketNotifications(){
          this.addWSEventListener({
              eventname:[NotifierConstants.webHookCreateNotification, NotifierConstants.webHookUpdateNotification, NotifierConstants.webHookDeleteNotification],
              callback:this.handleWebHookWorkspaceNotification,
              parent: "webhook"});
      },

      unRegisterforWebsocketNotifications(){
        this.removeWSEventListener({
            eventname:[NotifierConstants.webHookCreateNotification, NotifierConstants.webHookUpdateNotification, NotifierConstants.webHookDeleteNotification],
            callback:this.handleWebHookWorkspaceNotification,
            parent: "webhook"});
      },

    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("webHook", ["getTriggersFromServer", "getWebHookScriptFromServer", "deleteExistingWebHook"]),
  },
  created() {
    this.registerforWebsocketNotifications()
    // this.updateBinsList({label:"All",type:"all"});
    this.getWebHookData();
  },
  beforeDestroy(){
    this.unRegisterforWebsocketNotifications()
  }
};
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;

.activeclass {
  color: $active-blue;
}

.search-bar-comm-style {
  height: 30px;
  position: relative;
  select {
    border: $border-color;
    top: 0%;
    inset-inline-start:8%;
    height: 25px;
    padding-inline-start: 3px;
  }
}

.table-scroll {
  /*width:100%; */
  height: 100%;
  display: block;
  empty-cells: show;
  border: none!important;
  /* Decoration */
  border-spacing: 0;
  border: 1px solid;
  thead {
    color: $dull-text-color !important;
    position: relative;
    display: block;
    width: 100%;
  }
  tbody {
    display: block;
    position: relative;
    width: 100%;
    font-weight: 500;
    overflow: auto;
    max-height: calc(100vh - 280px);
  }
}

.table-scroll tr {
  width: 100%;
  display: flex;
  height:54px;
}

.table-scroll td,
.table-scroll th {
  flex-basis: 100%;
  flex-grow: 2;
  display: block;
  padding: 1rem;
  text-align: start;
}

.small-col {
  flex-basis: 10%;
}

.search-bar-comm-style {
  margin-top: 5px;
  .search-bar{
    background: $primary-background!important;
    height:40px;
    width: 250px !important;
    float: inline-start;
    padding-inline-start: 12px;
    margin: 0;
    margin-inline-end: 3%;  
    border: $border-color !important;
    padding-bottom:2px;
  }
}

.comm-user-row:hover {
  color: $active-blue;
  background: $bg-color-on-hover;
  td:first-child {
    text-decoration: underline;
  }
}

.height-set-for-component {
  height: calc(100% - 50px);
}

table .more-actions-btn {
  visibility: hidden;
}
table tr:hover .more-actions-btn {
  visibility: visible;
}

.search-bar-comm-style{
  height:30px;
  padding:16px;
  input{
    border:$border-color;
    height: 25px;
    padding-inline-start: 3%;
    width:30% !important;
  }
  svg{
    position: absolute;
    inset-inline-start:1px;
    top: 71%;
  }
}
.more-actions-div {
  position: absolute;
  height: 30px;
  width: 100px;
  padding: 6px;
  z-index: 99;
  border: $border-color;
  background: $primary-background;
  bottom: 0px;
  inset-inline-start:15%;
  ul {
    list-style-type: none;
    li {
      color: $text-color !important;
    }
    li:hover {
      color: $active-blue !important;
    }
  }
}

  .show-delete-icon:hover{
      position: relative;
      .parent-row-delete,  .parent-row-edit{
          visibility: visible;
      }
  }

  .parent-row-delete, .parent-row-edit{
      margin-inline-start: 10px;
      position: absolute;
      inset-inline-end: 0px;
      z-index: 1;
      background: #525252;
      border: 1px solid #262626;
      width: 55px;
      height: 44px;
      padding: 12px;
      top: 0px;
      border-radius: 0px 5px 5px 0px;
      visibility: hidden;
      color: #fff;
  }

  .parent-row-edit{
      inset-inline-end:54px;
      border-radius: 5px 0px 0px 5px;
  }

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}


.activestatus {
  color: $active-green-color !important;
}

.primary-btn-style{
    button{
    height: 35px;
    width: 70px;
    font-size:14px;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}

::v-deep{
    .multiselect__content-wrapper{
      display:none;
    }
    .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background !important;
        border: $border-color !important;
    }
    .multiselect__option--highlight {
       background: $bg-color-on-hover !important;
    }
    .multiselect__content {
       background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__input:focus{
      outline:none;
      box-shadow: none;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color:$text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color  !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: 12px !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:40%;
    }
    .multiselect__option--selected{
       background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: relative;
        display: block;
        background: $text-color;
        width: 100%;
        max-height: 240px;
        overflow: auto;
        border: 1px solid $text-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
     .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background!important;
        height: $input-field-height;
        min-height: 38px;
    }

    .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue !important;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-start;
            display:none;
            margin-inline-start:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }
}

.learn-about-text-styles{
  width: 200px !important;
  color:$learn-about-text-color;
  text-align: end;
  padding-inline-end: 17px;
  margin-top:10px;
  svg{
    margin-inline-end: 2px;
    margin-bottom: 3px;
  }
}

.learn-about-text-styles:hover{
  text-decoration: underline;
  color:$learn-about-text-color-hover;
}
</style>